export default function TypePhone({ value }) {
  return <div>{value}</div>
}
